export default __webpack_public_path__ + "static/media/Crate.a00e46fd.png";